import { isOneOf } from './isOneOf';
import { isNonOwaError } from './isNonOwaError';
import { TraceErrorObject, EmptyErrorStack } from 'owa-trace';

const knownExternalStrings: string[] = [
    'https://swc.cdn.skype.com',
    'https://acdn.adnxs.com/',
    'https://s.aolcdn.com',
    '/resources/suiteux-shell/',
    'lpcres.delve.office.com/',
    'jac.yahoosandbox.com',
    // This error means that ResizeObserver was not able to deliver all
    // observations within a single animation frame. It is benign
    'ResizeObserver loop ',
    '{"isCanceled":true}',
    '{"resultCode":2,"isAdalException":false,"_typeSpec":"TokenRetrievalError"}',
    '{"status":500}',
];

const knownExternalStringsWithNoStack: string[] = [
    // these errors come from the suite header and give no call stack
    'Unhandled Rejection: Already Initialized',
];
export function isExternalError(message: string, error: TraceErrorObject): boolean {
    if (isOneOf(knownExternalStrings, message)) {
        return true;
    }
    if (error) {
        if (error.external) {
            return true;
        }
        if (error.stack) {
            return (
                isNonOwaError(error.stack) ||
                isOneOf(knownExternalStrings, error.stack) ||
                (error.stack == EmptyErrorStack &&
                    isOneOf(knownExternalStringsWithNoStack, error.stack))
            );
        }
    }
    return false;
}
